- adviser:
    link: https://www.coord.c.titech.ac.jp/m/defago/
    name:
      en: Prof. Xavier Défago
      ja: Xavier Défago 教授
  affiliation:
    en: School of Computing, Tokyo Institute of Technology, Japan (currently called Institute of Science Tokyo)
    ja: 東京工業大学 情報理工学院 (現 東京科学大学)
  degree:
    en: Doctor of Engineering in Artificial Intelligence
    ja: 博士 (工学)
  link:
    en: https://www.titech.ac.jp/english/
    ja: https://www.titech.ac.jp/
  term:
    en: Apr. 2020 - Mar. 2023
    ja: 2020年4月 - 2023年3月
- adviser:
    link: https://www.coord.c.titech.ac.jp/m/defago/
    name:
      en: Prof. Xavier Défago
      ja: Xavier Défago 教授
  affiliation:
    en: Graduate Major in Artificial Intelligence, School of Computing, Minor Major
      in Physics, Tokyo Institute of Technology, Japan
    ja: "東京工業大学 情報理工学院 知能情報コース, 副専門: 物理学コース"
  degree:
    en: Master of Engineering
    ja: 修士 (工学)
  link:
    en: https://www.titech.ac.jp/english/
    ja: https://www.titech.ac.jp/
  term:
    en: Apr. 2018 - Mar. 2020
    ja: 2018年4月 - 2020年3月
- adviser:
    link: https://www.coord.c.titech.ac.jp/m/defago/
    name:
      en: Prof. Xavier Défago
      ja: Xavier Défago 教授
  affiliation:
    en: Department of Computer Science, Tokyo Institute of Technology, Japan
    ja: 東京工業大学 工学部情報工学科
  degree:
    en: Bachelor of Engineering
    ja: 学士 (工学)
  link:
    en: https://www.titech.ac.jp/english/
    ja: https://www.titech.ac.jp/
  term:
    en: Apr. 2014 - Mar. 2018
    ja: 2014年4月 - 2018年3月
